import { render, staticRenderFns } from "./CommonSectionLight.vue?vue&type=template&id=ccf4ced2&scoped=true&"
import script from "./CommonSectionLight.vue?vue&type=script&lang=js&"
export * from "./CommonSectionLight.vue?vue&type=script&lang=js&"
import style0 from "./CommonSectionLight.vue?vue&type=style&index=0&id=ccf4ced2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf4ced2",
  null
  
)

export default component.exports